// These third-party teams are excluded from Shipping settings in both navigation versions.
export function isRestrictedShippingTeam(teamId: string): boolean {
  return [
    "68a50f1378bdf9a9c1352e8b",
    "68a51f39ad07ff22f074fb25",
    "68a51f7715aa9428462967c6",
    "68a52001e14afead23f253cd",
    "68a51fbf1aa2c4f5c2b6c0c3",
  ].includes(teamId);
}

export function canViewScanningSettings(
  omsEnabled: boolean,
  canManageFulfillmentSettings: boolean,
): boolean {
  return omsEnabled && canManageFulfillmentSettings;
}
